module.exports = __webpack_public_path__ + "static/4-e393e9881ca39a57425b72bc2eab00cb.png";